module.exports = __webpack_public_path__ + "static/pasture-3331838651a8d87a587b3aadd7016f65.jpg";